import DataTable from '../../components/DataTable';
import { fmtDate } from '../../utils/ruDates';

const AI_AGENT_NAMES = {
    analyst: 'Аналитик',
    product: 'Товарный',
    reference: 'Справочный',
    seo: 'SEO',
    ads: 'Рекламный',
    pricing: 'Цены',
    reviews: 'Отзывы',
    visual: 'Визуал',
    fbs: 'FBS',
    dbs: 'DBS',
    fbo: 'FBO',
    pickup: 'Вывоз',
    certificates: 'Сертификаты',
    launch: 'Запуск',
    support: 'Поддержка',
};

function TaskList({
    tasks,
    companyUsers,
    taskStatusLabels,
    getWorkspaceById,
    getUserLabel,
    onOpenTask
}) {
    const columns = [
        { key: 'created_at', label: 'Создано', render: (task) => task.created_at ? fmtDate(task.created_at) : '-' },
        { key: 'due_at', label: 'Дата выполнения', render: (task) => task.due_at ? fmtDate(task.due_at) : '-' },
        { key: 'title', label: 'Тема', render: (task) => task.title },
        { key: 'workspace', label: 'Проект', render: (task) => task.workspace_name || getWorkspaceById(task.workspace_id)?.name || 'Без проекта' },
        {
            key: 'assignee',
            label: 'Исполнитель',
            render: (task) => {
                if (task.assignee_type === 'ai_agent' && task.ai_agent_slug) {
                    return <span>{`AI ${AI_AGENT_NAMES[task.ai_agent_slug] || task.ai_agent_slug}`}</span>;
                }
                const assignee = companyUsers.find((item) => item.id === task.assignee_id);
                return assignee ? getUserLabel(assignee) : '—';
            }
        },
        {
            key: 'status',
            label: 'Статус',
            render: (task) => (
                <span className={`chip chip--status-${task.status}`}>
                    {taskStatusLabels[task.status] || task.status}
                </span>
            )
        },
        {
            key: 'result_binding',
            label: 'Привязка',
            render: (task) => task.has_result_binding ? (
                <span className="chip chip--status-done">Есть</span>
            ) : (
                <span className="muted">Нет</span>
            )
        },
        { key: 'tags', label: 'Теги', render: (task) => (task.tags || []).length ? task.tags.join(', ') : '-' },
        {
            key: 'overdue',
            label: 'Просрочка',
            render: (task) => task.overdue ? <span className="chip chip--danger">Просрочено</span> : <span className="muted">-</span>
        }
    ];

    return (
        <DataTable
            className="tasks__table"
            headerClassName="tasks__row tasks__row--head"
            rowClassName="tasks__row tasks__row--clickable"
            columns={columns}
            rows={tasks}
            getRowKey={(task) => task.id}
            onRowClick={(task) => onOpenTask(task.id)}
        />
    );
}

export default TaskList;
